import i18n from "../i18n";
import api from "./api";
import type {
  IWashingClassSettings,
  IUpdateWashingClassSettingsPayload,
} from "./api.types";

// Types are defined in api.types.ts (canonical location) and re-exported here
// for backwards compatibility with existing imports from settings.service.
export type {
  VehicleType,
  ServiceType,
  WashClass,
  ICarWashClassEntry,
  ICarWashClassCombo,
  IWashingClassSettings,
  IUpdateWashingClassSettingsPayload,
  IBulkRecomputeResult,
} from "./api.types";

export const getWashingClassSettings = async (): Promise<IWashingClassSettings> => {
  try {
    const response = await api.get("/admins/settings/washing-class");
    return response.data.data;
  } catch (error: any) {
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || i18n.t("serviceErrors.fetchWashingClassSettings")
      );
    }
    throw new Error(i18n.t("serviceErrors.serverError"));
  }
};

export const updateWashingClassSettings = async (
  payload: IUpdateWashingClassSettingsPayload
): Promise<IWashingClassSettings> => {
  try {
    const response = await api.put("/admins/settings/washing-class", payload);
    return response.data.data.settings;
  } catch (error: any) {
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || i18n.t("serviceErrors.updateWashingClassSettings")
      );
    }
    throw new Error(i18n.t("serviceErrors.serverError"));
  }
};
